import clientFieldsMixin from "@/mixins/clientFieldsMixin";

/**
 * Tracks whether the client selected in the dropdown has an Inform tenant.
 *
 * Opt-in rather than part of `activeClientMixin`, which many components use without
 * needing this lookup. `clientHasInformTenant` reads false until the lookup resolves,
 * when it fails, and while a newly selected client is still being looked up. A screen
 * that needs other client fields too should use `clientFieldsMixin` directly, so they
 * share one lookup.
 */
export default clientFieldsMixin({ clientHasInformTenant: "informTenantId" });
